import { SVGIconProps } from '../types/svg';

export const Paiement = (props: SVGIconProps) => (
    <svg width="50" height="51" viewBox="0 0 50 51" fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
        <path d="M9.38946 17.865L41.6321 20.2488" stroke="#278BE5" strokeWidth="0.5" />
        <path d="M9.10575 21.7035L41.3483 24.0873" stroke="#278BE5" strokeWidth="0.5" />
        <path
            d="M18.2759 28.1704C19.5479 28.2645 20.5028 29.3718 20.4087 30.6437C20.3147 31.9157 19.2073 32.8705 17.9354 32.7765M11.9642 30.0194C12.0583 28.7475 13.1656 27.7926 14.4375 27.8866C15.7095 27.9807 16.6644 29.088 16.5703 30.3599C16.4763 31.6319 15.3689 32.5868 14.097 32.4927C12.8251 32.3987 11.8702 31.2913 11.9642 30.0194Z"
            stroke="#FF8A02" />
        <rect x="9.31784" y="13.6144" width="33.1004" height="22.3235" rx="5"
              transform="rotate(4.22836 9.31784 13.6144)" stroke="#00354F" strokeLinejoin="round" />
    </svg>
)